import { cn } from "../../lib/utils.js";

/** Shared internal-workspace sidebar widths (Reports / Contacts / Campaigns / Settings). */
export const WORKSPACE_INTERNAL_SIDEBAR_EXPANDED_PX = 216;
export const WORKSPACE_INTERNAL_SIDEBAR_COLLAPSED_PX = 52;

export const WORKSPACE_INTERNAL_SIDEBAR_ASIDE_CLASS =
  "hidden min-h-0 shrink-0 flex-col overflow-hidden border-e border-border/60 bg-surface transition-[width] duration-200 ease-in-out motion-reduce:transition-none lg:flex";

export function workspaceInternalNavItemClass(active: boolean, collapsed: boolean): string {
  return cn(
    "flex w-full items-center gap-2 overflow-hidden rounded-md px-2 py-1.5 text-start no-underline transition-colors duration-150 motion-reduce:transition-none",
    collapsed ? "justify-center px-0" : null,
    active
      ? "bg-surface-muted font-semibold text-foreground"
      : "font-medium text-foreground/80 hover:bg-surface-muted/70",
  );
}

export function workspaceInternalNavLabelClass(showLabels: boolean): string {
  return cn(
    "overflow-hidden whitespace-nowrap text-[0.8125rem] leading-5 transition-opacity duration-200 motion-reduce:transition-none",
    showLabels ? "min-w-0 flex-1 opacity-100" : "w-0 flex-none opacity-0",
  );
}
